import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';

import './AutomaticActionOptions.scss';

import config from '../../../config/config';
import {
  AUTOMATIC_TRANSACTION_DEFER,
  AUTOMATIC_TRANSACTION_DELETE,
  DELETE_AUTO_RMD,
} from '../../../redux/modules/modals/modals.module';
import { moduleActions } from '../../../redux/modules';
import {
  APP_TOLL_FREE_NUMBER,
  COLLEGE_FUND_NOTE_PHONE_NUMBERS,
  RECURRING_BUY,
  RECURRING_SELL,
  RECURRING_EXCHANGE,
  TOLL_FREE_NUMBER,
  AGREEMENT_TYPES,
  RMD,
} from '../../../settings/settings';
import If from '../../Shared/If/If';
import Phone from '../../Shared/Phone/Phone';
import { TOOLTIP_POSITION_BOTTOM } from '../../../utils/dom-utils';
import ToolTip from '../../Shared/ToolTip/ToolTip';
import { getHasCollegeOnly } from '../../../redux/modules/productTypes/productType.selectors';
import { isProductType529 } from '../../../utils/funds/funds-utility';
import { isAPP, isRAS } from '../../../utils/advice/advice-utility';
import { appendBasePath } from '../../../utils/nav.utils';
import {
  isCustomerWebViewEnabled,
  isSalesforceRep,
} from '../../../redux/modules/authentication/authentication.module.selectors';
import {
  automaticTipText,
  cantEditText,
} from '../../../utils/automatic/automatic-utils';
import {
  doesEverySystematicHaveAnAgreement,
  getRMDAgreements,
  getSystematicActivityRMDs,
} from '../../../redux/modules/RMD/RMDSetting.selectors';
import {
  getIsExistingRMDTrust,
  getIsRMDFundNonIRA,
} from '../../../redux/modules/shoppingCart/shoppingCart.selectors';

class AutomaticActionOption extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: true,
    };
  }

  getPhoneNumberByProductType(productType) {
    if (isAPP(productType)) {
      return APP_TOLL_FREE_NUMBER;
    } else if (isProductType529(productType)) {
      return COLLEGE_FUND_NOTE_PHONE_NUMBERS[productType];
    } else {
      return TOLL_FREE_NUMBER;
    }
  }

  render() {
    const {
      actions: { openModal },
      isSalesforceRep,
      customerWebViewEnabled,
      fund,
      getHasCollegeOnly,
      type,
      hasRestrictedService,
      isExistingRMDTrust,
      isRMDFundNonIRA,
      systematicAndAgreement,
    } = this.props;

    //legacy sell link href={`${config.clxUrl}/aaweb1/transactions/page/transact-trade/automatic-activity/${linkText}/edit.otc?preInitialize=true&activityIDs=${fund.encryptedUniqueKey}&shouldReturnToLaunchPoint=true`}
    const pendingTrade = fund.pendingTrade
      ? fund.pendingTrade
      : fund.electionAgreementUniqueId1 === 0 &&
        fund.electionAgreementUniqueId2 === 0 &&
        type !== RECURRING_EXCHANGE;
    const featureStatus = fund.featureStatus ? fund.featureStatus : {};
    const isRMD = fund.disbursementType?.enumerationID === 11;

    const isInherited =
      fund.agreementType === AGREEMENT_TYPES.TRADITIONAL_IRA_DECEASED_BENE ||
      fund.agreementType === AGREEMENT_TYPES.ROTH_IRA_DECEASED_BENE;
    const transactionText =
      type === RECURRING_BUY
        ? 'Automatic Buy'
        : type === RECURRING_SELL
        ? 'Automatic Sell'
        : 'Automatic Exchange';
    const isAPPorRAS = isAPP(fund.productType) || isRAS(fund.productType);
    return (
      <div>
        <If
          test={
            (fund.specialPayee ||
              fund.disbursementType?.enumerationID === 10 ||
              isInherited) &&
            !isRMD
          }
        >
          <div>
            <ToolTip
              message={cantEditText}
              callerText={
                <span className="automatic-action-options-tooltipLabel">
                  Call to Edit
                </span>
              }
              placement={TOOLTIP_POSITION_BOTTOM}
            />
          </div>
        </If>
        <If test={isRMD && type !== RMD}>
          <div>
            <ToolTip
              message={
                <div className="automatic-action-options-toolTip">
                  Changes to your Required Minimum Distribution can be made by
                  calling <Phone phoneNumber={'(888) 421-0563'} />
                </div>
              }
              callerText={
                <span className="automatic-action-options-tooltipLabel">
                  Call to Edit
                </span>
              }
              placement={TOOLTIP_POSITION_BOTTOM}
            />
          </div>
        </If>
        <If
          test={
            pendingTrade &&
            featureStatus.enumerationID === 100 &&
            !isRMD &&
            type !== RMD
          }
        >
          <div>
            <ToolTip
              message={
                <div className="automatic-action-options-toolTip">
                  Adding a new{' '}
                  {getHasCollegeOnly
                    ? 'Automatic Monthly Contribution'
                    : transactionText}{' '}
                  may take up to three business days to process. Call{' '}
                  <Phone
                    phoneNumber={this.getPhoneNumberByProductType(
                      fund.productType
                    )}
                  />{' '}
                  to make an update.
                </div>
              }
              callerText={'Pending'}
              placement={TOOLTIP_POSITION_BOTTOM}
            />
          </div>
        </If>
        <If
          test={pendingTrade && featureStatus.enumerationID === 101 && !isRMD}
        >
          <div>
            <ToolTip
              message={
                <div className="automatic-action-options-toolTip">
                  Deleting an{' '}
                  {getHasCollegeOnly
                    ? 'Automatic Monthly Contribution'
                    : transactionText}{' '}
                  may take up to three business days to process. Call{' '}
                  <Phone
                    phoneNumber={this.getPhoneNumberByProductType(
                      fund.productType
                    )}
                  />{' '}
                  to make an update.
                </div>
              }
              callerText={'Delete Pending'}
              placement={TOOLTIP_POSITION_BOTTOM}
            />
          </div>
        </If>
        <If
          test={
            pendingTrade &&
            featureStatus.enumerationID === 102 &&
            !isRMD &&
            !isAPPorRAS
          }
        >
          <div>
            <ToolTip
              message={automaticTipText(fund)}
              callerText={'Update Pending'}
              placement={TOOLTIP_POSITION_BOTTOM}
            />
          </div>
        </If>
        <If test={type === RMD}>
          {!(!customerWebViewEnabled && isSalesforceRep) ? (
            <div>
              {isExistingRMDTrust ||
              fund.specialPayee ||
              !systematicAndAgreement ||
              isRMDFundNonIRA ||
              fund.isPoa ? (
                <ToolTip
                  message={
                    <div className="automatic-action-options-toolTip">
                      Changes to your Required Minimum Distribution can be made
                      by calling <Phone phoneNumber={'(888) 421-0563'} />
                    </div>
                  }
                  callerText={
                    <span className="automatic-action-options-tooltipLabel">
                      Call to Edit
                    </span>
                  }
                  placement={TOOLTIP_POSITION_BOTTOM}
                />
              ) : fund.pending ? (
                <a
                  className="automatic-action-options-action-choice college-branded-link"
                  href={`${config.url}/usis/rmd-tool/`}
                  rel="noreferrer"
                >
                  Manage Auto-RMD
                </a>
              ) : (
                <div>
                  <a
                    className="automatic-action-options-action-choice college-branded-link"
                    href={`${config.url}/usis/rmd-tool/edit/destination`}
                  >
                    Edit
                  </a>
                  <span className="automatic-action-options-spacer"></span>
                  <a
                    className="automatic-action-options-action-choice college-branded-link"
                    onClick={() => {
                      openModal(DELETE_AUTO_RMD, {
                        fund: fund,
                        type: type,
                      });
                    }}
                  >
                    Delete
                  </a>
                </div>
              )}
            </div>
          ) : (
            <div>
              <ToolTip
                message={
                  <div className="automatic-action-options-toolTip">
                    Changes to Automatic RMDs are not supported in this flow.
                    Refer to current policies & procedures for how to modify
                    this transaction.
                  </div>
                }
                callerText={
                  <span className="automatic-action-options-tooltipLabel">
                    Automatic RMD
                  </span>
                }
                placement={TOOLTIP_POSITION_BOTTOM}
              />
            </div>
          )}
        </If>
        <If
          test={
            (!hasRestrictedService &&
              !pendingTrade &&
              !fund.specialPayee &&
              !isInherited &&
              type !== RMD &&
              fund.disbursementType.enumerationID !== 11 &&
              fund.disbursementType.enumerationID !== 10) ||
            isAPPorRAS
          }
        >
          <If test={type === RECURRING_SELL}>
            <a
              className="automatic-action-options-action-choice college-branded-link"
              href={`${config.url}${
                isSalesforceRep
                  ? appendBasePath(
                      '/salesforce/automatic/sell/edit?activityIDs='
                    )
                  : appendBasePath('/automatic/sell/edit?activityIDs=')
              }${fund.encryptedUniqueKey}`}
            >
              Edit
            </a>
          </If>
          <If test={type === RECURRING_BUY}>
            <a
              className="automatic-action-options-action-choice college-branded-link"
              href={`${config.url}${
                isSalesforceRep
                  ? appendBasePath(
                      '/salesforce/automatic/buy/edit?activityIDs='
                    )
                  : appendBasePath('/automatic/buy/edit?activityIDs=')
              }${fund.encryptedUniqueKey}`}
            >
              Edit
            </a>
          </If>
          <If test={type === RECURRING_EXCHANGE}>
            <a
              className="automatic-action-options-action-choice college-branded-link"
              href={`${config.url}${
                isSalesforceRep
                  ? appendBasePath(
                      '/salesforce/automatic/exchange/edit?activityIDs='
                    )
                  : appendBasePath('/automatic/exchange/edit?activityIDs=')
              }${fund.encryptedUniqueKey}`}
            >
              Edit
            </a>
          </If>
          <If
            test={
              type === RECURRING_BUY &&
              !isAPP(fund.productType) &&
              !isRAS(fund.productType)
            }
          >
            <div className="automatic-action-options-spacer" />
            <a
              className="automatic-action-options-action-choice college-branded-link"
              onClick={() => {
                openModal(AUTOMATIC_TRANSACTION_DEFER, { fund: fund });
              }}
            >
              Skip
            </a>
          </If>
          <If test={type === RECURRING_BUY}>
            <div className="automatic-action-options-spacer" />
            <a
              className="automatic-action-options-action-choice college-branded-link"
              onClick={() => {
                openModal(AUTOMATIC_TRANSACTION_DELETE, {
                  fund: fund,
                  type: type,
                });
              }}
            >
              Delete
            </a>
          </If>
          <If test={type === RECURRING_EXCHANGE}>
            <div className="automatic-action-options-spacer" />
            <a
              className="automatic-action-options-action-choice college-branded-link"
              onClick={() => {
                openModal(AUTOMATIC_TRANSACTION_DELETE, {
                  fund: fund,
                  type: type,
                });
              }}
            >
              Delete
            </a>
          </If>
          <If test={type === RECURRING_SELL}>
            <div className="automatic-action-options-spacer" />
            <a
              className="automatic-action-options-action-choice college-branded-link"
              onClick={() => {
                openModal(AUTOMATIC_TRANSACTION_DELETE, {
                  fund: fund,
                  type: type,
                });
              }}
            >
              Delete
            </a>
          </If>
        </If>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isSalesforceRep: isSalesforceRep(state),
    customerWebViewEnabled: isCustomerWebViewEnabled(state),
    getHasCollegeOnly: getHasCollegeOnly(state),
    isExistingRMDTrust: getIsExistingRMDTrust(state),
    rmdAgreements: getRMDAgreements(state),
    systematics: getSystematicActivityRMDs(state),
    systematicAndAgreement: doesEverySystematicHaveAnAgreement(state),
    isRMDFundNonIRA: getIsRMDFundNonIRA(state),
  };
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      openModal: moduleActions.openModal,
    },
    dispatch
  ),
  dispatch,
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  AutomaticActionOption
);
